import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBenefitInstant = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 64,
		height: 64,
		fill: "#1E1E1E"
	}), /* @__PURE__ */ _jsxs("g", {
		id: "Friends with Benefits - Welcome Screen",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M-1436 -814C-1436 -924.457 -1346.46 -1014 -1236 -1014H6250C6360.46 -1014 6450 -924.457 6450 -814V2583C6450 2693.46 6360.46 2783 6250 2783H-1236C-1346.46 2783 -1436 2693.46 -1436 2583V-814Z",
				fill: "#252525"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M-1236 -1014V-1013H6250V-1014V-1015H-1236V-1014ZM6450 -814H6449V2583H6450H6451V-814H6450ZM6250 2783V2782H-1236V2783V2784H6250V2783ZM-1436 2583H-1435V-814H-1436H-1437V2583H-1436ZM-1236 2783V2782C-1345.9 2782 -1435 2692.9 -1435 2583H-1436H-1437C-1437 2694.01 -1347.01 2784 -1236 2784V2783ZM6450 2583H6449C6449 2692.9 6359.9 2782 6250 2782V2783V2784C6361.01 2784 6451 2694.01 6451 2583H6450ZM6250 -1014V-1013C6359.9 -1013 6449 -923.905 6449 -814H6450H6451C6451 -925.009 6361.01 -1015 6250 -1015V-1014ZM-1236 -1014V-1015C-1347.01 -1015 -1437 -925.009 -1437 -814H-1436H-1435C-1435 -923.905 -1345.9 -1013 -1236 -1013V-1014Z",
				fill: "white",
				fillOpacity: .1
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Friends with Benefits - Registrieren - Mobile",
				children: [/* @__PURE__ */ _jsx("rect", {
					width: 390,
					height: 3526,
					transform: "translate(-163 -790)",
					fill: "white"
				}), /* @__PURE__ */ _jsx("g", {
					id: "Frame 17",
					children: /* @__PURE__ */ _jsx("g", {
						id: "Frame 16",
						children: /* @__PURE__ */ _jsxs("g", {
							id: "section-configurator",
							children: [/* @__PURE__ */ _jsx("rect", {
								width: 390,
								height: 1024,
								transform: "translate(-163 -526)",
								fill: "#F9F5F0"
							}), /* @__PURE__ */ _jsxs("g", {
								id: "section-stage",
								children: [/* @__PURE__ */ _jsx("rect", {
									width: 358,
									height: 675,
									transform: "translate(-147 -225)",
									fill: "#F9F5F0"
								}), /* @__PURE__ */ _jsx("g", {
									id: "benefit-container",
									children: /* @__PURE__ */ _jsxs("g", {
										id: "sl-ticket",
										children: [/* @__PURE__ */ _jsx("path", {
											id: "Color",
											d: "M6.37402 14.1162C17.652 19.3061 44.5091 27.2021 61.7129 17.2695L61.8018 27.3076C61.7723 27.3072 61.7425 27.3057 61.7129 27.3057C57.9125 27.3058 54.832 30.387 54.832 34.1875C54.8322 37.9878 57.9126 41.0682 61.7129 41.0684C61.7837 41.0684 61.8545 41.0646 61.9248 41.0625L62 49.3838C46.5167 45.3696 14.8798 50.6408 1.5 40.7822C1.84249 38.3848 2.14792 36.4072 2.44336 34.627C2.88015 34.7139 3.33161 34.7607 3.79395 34.7607C7.5945 34.7607 10.6758 31.6795 10.6758 27.8789C10.6757 24.4969 8.23512 21.6866 5.01953 21.1084C5.41154 19.1249 5.85744 16.8467 6.37402 14.1162Z",
											fill: "#FF6047"
										}), /* @__PURE__ */ _jsx("path", {
											id: "Black",
											d: "M15.2725 43.4541L16.0186 43.5342L15.7461 46.0801L14.2539 45.9199L14.5273 43.375L15.2725 43.4541ZM40.5 34.25C42.8472 34.25 44.75 36.1528 44.75 38.5C44.75 40.8472 42.8472 42.75 40.5 42.75C38.1528 42.75 36.25 40.8472 36.25 38.5C36.25 36.1528 38.1528 34.25 40.5 34.25ZM44.498 26.5605L26.498 42.5605L25.502 41.4395L43.502 25.4395L44.498 26.5605ZM40.5 35.75C38.9812 35.75 37.75 36.9812 37.75 38.5C37.75 40.0188 38.9812 41.25 40.5 41.25C42.0188 41.25 43.25 40.0188 43.25 38.5C43.25 36.9812 42.0188 35.75 40.5 35.75ZM16.2725 34.1211L17.0186 34.2012L16.4727 39.292L15.7275 39.2119L14.9814 39.1318L15.5273 34.041L16.2725 34.1211ZM29.5 25.25C31.8472 25.25 33.75 27.1528 33.75 29.5C33.75 31.8472 31.8472 33.75 29.5 33.75C27.1528 33.75 25.25 31.8472 25.25 29.5C25.25 27.1528 27.1528 25.25 29.5 25.25ZM29.5 26.75C27.9812 26.75 26.75 27.9812 26.75 29.5C26.75 31.0188 27.9812 32.25 29.5 32.25C31.0188 32.25 32.25 31.0188 32.25 29.5C32.25 27.9812 31.0188 26.75 29.5 26.75ZM17.2725 24.7881L18.0186 24.8682L17.4727 29.959L16.7275 29.8789L15.9814 29.7988L16.5273 24.708L17.2725 24.7881ZM18.7461 18.0801L18.4727 20.625L17.7275 20.5459L16.9814 20.4658L17.2539 17.9199L18.7461 18.0801Z",
											fill: "#311123"
										})]
									})
								})]
							})]
						})
					})
				})]
			})
		]
	})]
});
export default SvgBenefitInstant;
